import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class blockquoteRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("blockquote")}`;
    this.config = config;
  }
}
